import { render, staticRenderFns } from "./sub-image-card.vue?vue&type=template&id=72c7848a&scoped=true&"
import script from "./sub-image-card.vue?vue&type=script&lang=js&"
export * from "./sub-image-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7848a",
  null
  
)

export default component.exports